import { Implementation } from "@/backend/models/implementation";
import { Client } from "./client";
import { ImplementationCreateData, ImplementationReadAllResponse, ImplementationReply } from "@/backend/access/implementation/types";
import { FusaReply } from "@/types/replyTypes";

export class ImplementationController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  readAllImplementations(): Promise<ImplementationReadAllResponse> {
    return this.client.read(`/api/implementations`);
  }

  readAllMatchingFunctionalInterface(functionalInterfaceId: string): Promise<ImplementationReadAllResponse> {
    return this.client.read(`/api/implementations/matching-functional-interface/${functionalInterfaceId}`);
  }

  readImplementation(id: string): Promise<ImplementationReply> {
    return this.client.read(`/api/implementations/${id}`);
  }

  createImplementation(request: Omit<ImplementationCreateData, 'orgId'>): Promise<ImplementationReply> {
    return this.client.create(`/api/implementations`, request);
  }

  createFromInterface(interfaceId: string): Promise<ImplementationReply> {
    return this.client.create(`/api/implementations/createFromInterface/${interfaceId}`, {});
  }

  updateImplementation(implementation: Implementation): Promise<ImplementationReply> {
    return this.client.update(`/api/implementations/${implementation.id}`, implementation);
  }

  deleteImplementation(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/implementations/${id}`);
  }
}